export interface JobStartDateAmount {
  StartDate?: Date;
  Amount: number;
  MaxAmount: number;
}
